import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTimeAdapter, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateDirective, TranslateService } from '@ngx-translate/core';

import { SasDynamicFormService } from '../sas-dynamic-form.service';
import { CustomTimeAdapterService, FormSubmittedService } from '@services';

@Component({
    selector: 'sas-timepicker-field-type',
    standalone: true,
    imports: [ReactiveFormsModule, FormlyModule, NgbTimepickerModule, NgClass, TranslateDirective],
    providers: [{ provide: NgbTimeAdapter, useClass: CustomTimeAdapterService }],
    template: `
        <div class="form-group mb-3">
            <label [for]="field.id"
                   [id]="field.id + 'Label'"
                   class="form-label"
                   [textContent]="field.props.label"
                   translate="{{field.props.label}}">
            </label>
            @if (field.props.required) {
            <span> *</span>
            }
            @if (helpText.length) {
            <div [title]="helpText" class="sas-inline-block">
                <i class="bi bi-info-circle-fill sas-info-icon" aria-hidden="true"></i>
            </div>
            }
            <ngb-timepicker [formControl]="formControl"
                            [readonlyInputs]="field.props.readonly!"
                            [spinners]="!field.props.readonly!"
                            [ngClass]="{'is-invalid' : field.formControl.invalid && (field.formControl.dirty || field.formControl.touched || formSubmittedService.isSubmitted())}"
                            required="{{field.props.required}}" />
            <div [id]="field.id + 'Desc'" role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback">
                <small>{{ sasDynamicFormService.getFieldErrorMessage(field) }}</small>
            </div>
        </div>
    `,
})
export class SasTimepickerFieldTypeComponent extends FieldType<FieldTypeConfig> {
    formSubmittedService = inject(FormSubmittedService);
    private translate = inject(TranslateService);
    sasDynamicFormService = inject(SasDynamicFormService);

    helpText: string = '';

    ngOnInit() {
        if (this.field.props['helptext']) {
            const helpText = this.translate.instant(this.field.props['helptext']);

            this.helpText = helpText === this.field.props['helptext'] ? '' : helpText;
        }
    }
}
